import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { DialogContent as MuiDialogContent } from "@material-ui/core";

import { DialogContentStyles } from "./commonStyles";

const DialogContentCommonComponent = props => (<MuiDialogContent {...props} />);

export default withStyles(DialogContentStyles)(DialogContentCommonComponent);
